import ReportComment from "./ReportComment";
import UserComment from "./UserComment";
import ExternalUserComment from "./ExternalUserComment";
import ReviewCommentInput from "./ReviewCommentInput";
import FileComment from "./FileComment";
import ExternalFileComment from "./ExternalFileComment";
import roles from "../models/Roles";

const ValuationReviewOverview = (props) => {
    const history = props.history;
    const summaryId = props.summaryId;
    const getHistory = props.getHistory;
    const valuerChat = props.valuerChat;

       return (
        <>
            <div className="valuation-overview-container">
                <div className="valuation-overview-grid-rows">
                    {valuerChat && history && history.map((entry) => {
                        return(
                            <>
                                {entry.type_id === 1  || entry.type_id === 8 ?
                                    <>
                                        <div className="valuation-comment-row-container">
                                            {entry.current_user
                                                ?
                                                <UserComment comment={entry.comment}
                                                             date={entry.entry_date}
                                                             user={entry.entry_user}/>
                                                :
                                                <ExternalUserComment comment={entry.comment}
                                                                     date={entry.entry_date}
                                                                     user={entry.entry_user}
                                                                     valuerChat={valuerChat}
                                                />
                                            }
                                        </div>
                                    </>
                                    : null
                                }
                                {entry.type_id === 2 ?
                                    <>
                                        <div className="valuation-comment-row-container">
                                            <ReportComment name={entry.status_name}
                                                           description={entry.status_description}
                                                           date={entry.entry_date}
                                                           status={entry.status_id}/>
                                        </div>
                                    </>
                                    : null
                                }
                                {entry.type_id === 5 || (entry.type_id === 9 && valuerChat) ?
                                    <>
                                        <div className="valuation-comment-row-container">
                                            {entry.current_user
                                                ?
                                                <FileComment comment={entry.comment}
                                                             date={entry.entry_date}
                                                             summary_id={summaryId}
                                                             valuerChat={valuerChat}
                                                             user={entry.entry_user}
                                                />
                                                :
                                                <ExternalFileComment comment={entry.comment}
                                                                     date={entry.entry_date}
                                                                     summary_id={summaryId}
                                                                     roleId={entry.entry_user.role_id}
                                                                     valuerChat={valuerChat}
                                                                     user={entry.entry_user}
                                                />
                                            }
                                        </div>
                                    </>
                                    : null
                                }
                            </>
                        )
                    })}
                    {!valuerChat && history && history.map((entry) => {
                        return(
                            <>
                                {entry.type_id === 1  || entry.type_id === 8 ?
                                    <>
                                        <div className="valuation-comment-row-container">
                                            {entry.entry_user.role_id === roles.ROLE_USER
                                            || entry.entry_user.role_id === roles.ROLE_ORGANISATION_ADMIN
                                            || entry.entry_user.role_id === roles.ROLE_ADMIN
                                                ?
                                                <UserComment comment={entry.comment}
                                                             date={entry.entry_date}
                                                             user={entry.entry_user}/>
                                                :
                                                <ExternalUserComment comment={entry.comment}
                                                                     date={entry.entry_date}
                                                                     user={entry.entry_user}
                                                                     valuerChat={valuerChat}
                                                />
                                            }
                                        </div>
                                    </>
                                    : null
                                }
                                {entry.type_id === 2 ?
                                    <>
                                        <div className="valuation-comment-row-container">
                                            <ReportComment name={entry.status_name}
                                                           description={entry.status_description}
                                                           date={entry.entry_date}
                                                           status={entry.status_id}/>
                                        </div>
                                    </>
                                    : null
                                }
                                {entry.type_id === 5 || (entry.type_id === 9 && valuerChat) ?
                                    <>
                                        <div className="valuation-comment-row-container">
                                            {entry.entry_user.role_id === roles.ROLE_USER
                                            || entry.entry_user.role_id === roles.ROLE_ORGANISATION_ADMIN
                                            || entry.entry_user.role_id === roles.ROLE_ADMIN
                                                ?
                                                <FileComment comment={entry.comment}
                                                             date={entry.entry_date}
                                                             summary_id={summaryId}
                                                             valuerChat={valuerChat}
                                                             user={entry.entry_user}
                                                />
                                                :
                                                <ExternalFileComment comment={entry.comment}
                                                                     date={entry.entry_date}
                                                                     summary_id={summaryId}
                                                                     roleId={entry.entry_user.role_id}
                                                                     valuerChat={valuerChat}
                                                                     user={entry.entry_user}
                                                />
                                            }
                                        </div>
                                    </>
                                    : null
                                }
                            </>
                        )
                    })}


                </div>
                <ReviewCommentInput summaryId={summaryId}
                                    getHistory={getHistory}
                                    view={"user"}
                                    valuerChat={valuerChat}
                />
            </div>
        </>
    )
}

export default ValuationReviewOverview